import { Alert, Stack, Typography } from '@mui/material'
import LoginLayout from '../../../layouts/login'
import { AuthLoginForm } from './AuthLoginForm'
import { Legales } from './Legales'

const Login = () => (
    <LoginLayout>
        <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
            <Typography variant="h4">Iniciar Sesión</Typography>
        </Stack>
        <Alert severity="info" sx={{ mb: 3 }}>
            Ingresa tus credenciales de acceso.
        </Alert>
        <AuthLoginForm />
        <Legales />
    </LoginLayout>
)
export { Login }

